module.exports = __webpack_public_path__ + "img/home-changes.4fd19ef3.png";